import React, { useEffect, useState } from 'react';
import './Orders.css'
import { db } from './firebase';
import { useStateValue } from "./StateProvider";
import Order from './Order';


function Orders() {
    const [{ basket, user }, dispatch] = useStateValue();
    const [orders, setOrders] = useState([]);
    const [date, setDate] = useState([]);
    const [timing, setTiming] = useState([]);
    useEffect(() => {
        fetchTiming();
    }, [])

    const fetchTiming = async()=>{
        const response = db.collection('Timing');
        const data = await response.get();
        data.docs.forEach(item=>{
            setTiming([...timing,item.data()])
           })
       
    }
    
    useEffect(() => {
        
        if (user) {
            db
            .collection('users')
            .doc(user?.email)
            .collection('orders')
            .orderBy('created', 'desc')
            .onSnapshot(snapshot => (
                setOrders(snapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })))
            ))
           
        } else([])
    }, [user]) 

    return (
        <div className='orders'>
            <h1>Your Orders</h1>
            
            <div className='orders__order'>
                {orders?.map(order => (
                    <Order order={order} />
                ))}
                
            </div>
            <div>

            </div>
            
        </div>
    )
}

export default Orders
